import ViewDriver from "../../../../components/@users/drivers/ViewDriver";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function DriverViewPage() {

    return (
        <ViewDriver 
            routeType={routeTypes.admin}
        />
    )
}       